import { Card, SectionHeader } from "../../components/lib";
import { ListRow } from "../../components/lib.overlay";
import { PLAYBOOKS, AI_TEAMMATES } from "../../mocks/aiData";

function teammateName(id: string) { return AI_TEAMMATES.find((t) => t.id === id)?.name ?? id; }

export default function Playbooks() {
  return (
    <div className="space-y-6" data-testid="ai-playbooks">
      <Card padded={false} testId="ai-pb-list">
        <div className="p-5" style={{ borderBottom: "1px solid var(--ph-border-subtle)" }}><SectionHeader eyebrow="Playbooks" title={`${PLAYBOOKS.length} automated flows`} /></div>
        <div className="p-2">
          {PLAYBOOKS.map((p) => (
            <ListRow key={p.id} testId={`ai-p-${p.id}`}
              label={<span>{p.name} · <span className="text-[10px]" style={{ color: "var(--ph-ai)" }}>{teammateName(p.ownerTeammateId)}</span></span>}
              sublabel={<>{p.scope} · triggers: {p.triggers.join(", ")}</>}
              trailing={<div className="text-right"><div className="text-sm tabular-nums" style={{ color: "var(--ph-ink-strong)" }}>{p.runsThisMonth} runs</div><div className="text-[10px]" style={{ color: "var(--ph-ink-muted)" }}>{p.outcomeSummary}</div></div>}
            />
          ))}
        </div>
      </Card>
    </div>
  );
}
